import Vue from 'vue'
import VueRouter from 'vue-router'
import { App, base } from '@/layouts'
import Home from '@/views/Home'
import { requiresAuth } from '@/lib/auth.js'
import rewardsRoutes from './rewards'
import unauthenticated from './unauthenticated'
import youRoutes from './you'

Vue.use(VueRouter)

const routes = [
  ...unauthenticated,

  {
    path: '',
    component: App,
    beforeEnter: requiresAuth,
    children: [
      {
        name: 'home',
        path: 'home',
        component: Home,
      },
      {
        path: "leads",
        component: base,
        children: [
          {
            name: 'leads/list',
            path: '',
            component: () => import('@/views/Leads/List'),
          },
          {
            path: ':id(\\d+)',
            component: base,
            children: [
              {
                name: 'leads/choose',
                path: 'choose',
                props: true,
                component: () => import('@/views/Leads/ChooseMethod'),
              },
              {
                name: 'leads/append',
                path: 'append',
                props: true,
                component: () => import('@/views/Leads/Append'),
              },
              {
                name: 'leads/show',
                path: '',
                props: true,
                component: () => import('@/views/Leads/Show'),
              },
              {
                name: 'leads/confirm',
                path: 'confirm',
                props: true,
                component: () => import('@/views/Leads/Confirm'),
              },
            ],
          },      
        ],
      },
      {
        path: 'pros',
        component: base,
        children: [
          {
            name: 'pros/list',
            path: '',
            component: () => import('@/views/Pro/List'),
          },
          {
            name: 'pros/show',
            path: ':pro_id(\\d+)',
            props: true,
            component: () => import('@/views/Pro/Show'),
          },    
        ],
      },
      { 
        path: 'referrals',
        component: base,
        children: [
          {
            name: 'referrals',
            path: '',
            component: () => import('@/views/Referrals/Service'),
          },
          {
            name: 'referrals/request',
            path: 'request',
            component: () => import('@/views/Referrals/ChooseCustomer'),
          },
          {
            name: 'referrals/method',
            path: 'method',
            component: () => import('@/views/Referrals/ChooseMethod'),
          },
          {
            name: 'referrals/pro',
            path: 'pro',
            component: () => import('@/views/Referrals/ChoosePro'),
          },
          {
            name: 'referrals/confirm',
            path: 'confirm',
            props: true,
            component: () => import('@/views/Referrals/Confirm'),
          },    
        ],
      },
      ...rewardsRoutes,
      {
        path: 'support',
        component: base,
        children: [
          {
            name: 'support/logs',
            path: 'logs',
            component: () => import('@/views/Support/Logs'),
          },
          {
            name: 'support/start',
            path: 'start',
            component: () => import('@/views/Support/GettingStarted'),
          },
          {
            name: 'support',
            path: '',
            component: () => import('@/views/Support'),
          },
        ]
      },
      ...youRoutes,
      {
        name: 'default',
        path: '',
        redirect: { name: 'referrals' },
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
